import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Card, Badge, InputGroup, Form, Row, Col } from 'react-bootstrap';
import { FaSearch, FaPlus, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

var ModalEmpreendimentosPdv = function (props) {
  var show = props.show;
  var onHide = props.onHide;
  var pdv = props.pdv;
  var onAlterou = props.onAlterou;

  var [vinculados, setVinculados] = useState([]);
  var [todosEmpreendimentos, setTodosEmpreendimentos] = useState([]);
  var [loading, setLoading] = useState(false);
  var [buscaDisponivel, setBuscaDisponivel] = useState('');
  var [buscaVinculado, setBuscaVinculado] = useState('');
  var [confirmacao, setConfirmacao] = useState({ show: false, item: null });
  var alterouRef = useRef(false);

  useEffect(function () {
    if (show && pdv) {
      alterouRef.current = false;
      carregarDados();
    }
    if (!show) {
      setVinculados([]);
      setTodosEmpreendimentos([]);
      setBuscaDisponivel('');
      setBuscaVinculado('');
    }
  }, [show]);

  var carregarDados = async function () {
    setLoading(true);
    try {
      var resVinculados = await api.listarEmpreendimentosPdv(pdv.codigo_pdv);
      setVinculados(resVinculados || []);
      var resTodos = await api.BuscarEmpreendimentosPDV();
      setTodosEmpreendimentos(resTodos || []);
    } catch (e) {
      toast.error('Erro ao carregar empreendimentos');
    } finally {
      setLoading(false);
    }
  };

  var handleVincular = async function (emp) {
    try {
      await api.vincularEmpreendimentoPdv({
        codigo_pdv: pdv.codigo_pdv,
        codigo_familia: emp.codigo,
      });
      toast.success('Empreendimento vinculado!');
      setVinculados(function (prev) {
        return prev.concat([{ codigo_familia: emp.codigo, nome_familia: emp.descricao }]);
      });
      alterouRef.current = true;
    } catch (e) {
      var msg = (e && e.response && e.response.data && e.response.data.message) || 'Erro ao vincular';
      toast.error(msg);
    }
  };

  var handlePedirDesvinculacao = function (item) {
    setConfirmacao({ show: true, item: item });
  };

  var handleConfirmarDesvinculacao = async function () {
    var item = confirmacao.item;
    setConfirmacao({ show: false, item: null });
    try {
      await api.desvincularEmpreendimentoPdv({
        codigo_pdv: pdv.codigo_pdv,
        codigo_familia: item.codigo_familia,
      });
      toast.success('Empreendimento desvinculado!');
      setVinculados(function (prev) {
        return prev.filter(function (v) { return v.codigo_familia !== item.codigo_familia; });
      });
      alterouRef.current = true;
    } catch (e) {
      toast.error('Erro ao desvincular');
    }
  };

  var handleFechar = function () {
    if (alterouRef.current && onAlterou) {
      onAlterou();
    }
    onHide();
  };

  var titulo = pdv ? 'Empreendimentos do PDV: ' + pdv.descricao : 'Empreendimentos';

  var filtrarDisponivel = function (e) {
    var t = buscaDisponivel.toLowerCase().trim();
    if (!t) return true;
    return (
      String(e.codigo).indexOf(t) >= 0 ||
      (e.descricao && e.descricao.toLowerCase().indexOf(t) >= 0)
    );
  };

  var disponivelFiltrados = todosEmpreendimentos.filter(filtrarDisponivel).slice(0, 50);
  var totalFiltrados = todosEmpreendimentos.filter(filtrarDisponivel).length;

  var vinculadosFiltrados = (function () {
    var t = buscaVinculado.toLowerCase().trim();
    if (!t) return vinculados;
    return vinculados.filter(function (v) {
      return (
        String(v.codigo_familia).indexOf(t) >= 0 ||
        (v.nome_familia && v.nome_familia.toLowerCase().indexOf(t) >= 0)
      );
    });
  })();

  return (
    <>
      <Modal show={show} onHide={handleFechar} size="lg" centered>
        <Modal.Header
          closeButton
          style={{ backgroundColor: '#0747a6', color: '#fff' }}
        >
          <Modal.Title style={{ fontSize: '1.1rem', color: '#fff' }}>{titulo}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="d-flex align-items-stretch">
            <Col md={6} className="d-flex">
              <Card className="border w-100 d-flex flex-column">
                <Card.Header
                  className="py-2 d-flex justify-content-between align-items-center"
                  style={{ backgroundColor: '#f8f9fa' }}
                >
                  <strong style={{ fontSize: '0.9rem' }}>Disponíveis</strong>
                  {todosEmpreendimentos.length > 0 && (
                    <Badge variant="secondary">{todosEmpreendimentos.length}</Badge>
                  )}
                </Card.Header>
                <div className="px-2 py-2" style={{ borderBottom: '1px solid #dee2e6' }}>
                  <InputGroup size="sm">
                    <InputGroup.Prepend>
                      <InputGroup.Text><FaSearch size={12} /></InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      placeholder="Filtrar por nome ou código..."
                      value={buscaDisponivel}
                      onChange={function (e) { setBuscaDisponivel(e.target.value); }}
                    />
                  </InputGroup>
                </div>
                <Card.Body className="p-0" style={{ flex: 1 }}>
                  {loading ? (
                    <p className="text-center py-3 mb-0">Carregando...</p>
                  ) : todosEmpreendimentos.length > 0 ? (
                    <div>
                      {totalFiltrados > 50 && (
                        <p className="text-muted small text-center py-1 mb-0">
                          Mostrando 50 de {totalFiltrados} — refine o filtro
                        </p>
                      )}
                      <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
                        {disponivelFiltrados.map(function (emp) {
                          var jaVinculado = vinculados.some(function (v) {
                            return v.codigo_familia === emp.codigo;
                          });
                          return (
                            <div
                              key={emp.codigo}
                              className="d-flex justify-content-between align-items-center px-3 py-2"
                              style={{
                                borderBottom: '1px solid #f0f0f0',
                                backgroundColor: jaVinculado ? '#e8f5e9' : 'transparent',
                              }}
                            >
                              <span style={{ fontSize: '0.9rem' }}>
                                <Badge variant="light" className="mr-1">{emp.codigo}</Badge>
                                {emp.descricao}
                              </span>
                              <span style={{ whiteSpace: 'nowrap' }}>
                                {jaVinculado ? (
                                  <Badge variant="success">vinculado</Badge>
                                ) : (
                                  <Button size="sm" variant="success" onClick={function () { handleVincular(emp); }}>
                                    <FaPlus />
                                  </Button>
                                )}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    <p className="text-muted small text-center py-3 mb-0">Nenhum empreendimento cadastrado.</p>
                  )}
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} className="d-flex">
              <Card className="border w-100 d-flex flex-column">
                <Card.Header
                  className="py-2 d-flex justify-content-between align-items-center"
                  style={{ backgroundColor: '#f8f9fa' }}
                >
                  <strong style={{ fontSize: '0.9rem' }}>Vinculados</strong>
                  <Badge variant="info">{vinculados.length}</Badge>
                </Card.Header>
                <div className="px-2 py-2" style={{ borderBottom: '1px solid #dee2e6' }}>
                  <InputGroup size="sm">
                    <InputGroup.Prepend>
                      <InputGroup.Text><FaSearch size={12} /></InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      placeholder="Filtrar por nome ou código..."
                      value={buscaVinculado}
                      onChange={function (e) { setBuscaVinculado(e.target.value); }}
                    />
                  </InputGroup>
                </div>
                <Card.Body className="p-0" style={{ flex: 1 }}>
                  {loading ? (
                    <p className="text-center py-3 mb-0">Carregando...</p>
                  ) : vinculados.length === 0 ? (
                    <p className="text-muted small text-center py-3 mb-0">Nenhum empreendimento vinculado.</p>
                  ) : vinculadosFiltrados.length === 0 ? (
                    <p className="text-muted small text-center py-3 mb-0">Nenhum resultado para o filtro.</p>
                  ) : (
                    <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
                      {vinculadosFiltrados.map(function (v) {
                        return (
                          <div
                            key={v.codigo_familia}
                            className="d-flex justify-content-between align-items-center px-3 py-2"
                            style={{ borderBottom: '1px solid #f0f0f0' }}
                          >
                            <span style={{ fontSize: '0.9rem' }}>
                              <Badge variant="light" className="mr-1">{v.codigo_familia}</Badge>
                              {v.nome_familia}
                            </span>
                            <Button size="sm" variant="danger" onClick={function () { handlePedirDesvinculacao(v); }}>
                              <FaTrash size={12} />
                            </Button>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleFechar}>Fechar</Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={confirmacao.show}
        onHide={function () { setConfirmacao({ show: false, item: null }); }}
        centered
        size="sm"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '1rem' }}>Confirmar Remoção</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {confirmacao.item
            ? 'Deseja desvincular o empreendimento "' + confirmacao.item.nome_familia + '"?'
            : ''}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            size="sm"
            onClick={function () { setConfirmacao({ show: false, item: null }); }}
          >
            Cancelar
          </Button>
          <Button variant="danger" size="sm" onClick={handleConfirmarDesvinculacao}>
            Remover
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalEmpreendimentosPdv;
